import React, { useState } from 'react';
import { Title, Content, Container, Inputs } from './DeleteAccountPage.styles';
import Button from '../../components/utils/Button/Button';
import { Input } from '../../components/utils/Input/Input.styles';
import PhoneNumberInput from '../../components/utils/PhoneInput/PhoneNumberInput';

const DeleteAccountPage = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const onDelete = () => {};

  return (
    <Container>
      <Content>
        <Title>Delete Your Account</Title>
        <PhoneNumberInput phone={phoneNumber} setPhone={setPhoneNumber} />
        <Inputs>
          <Input
            placeholder="First Name"
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            style={{ maxWidth: '47%' }}
          />
          <Input
            placeholder="Last Name"
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            style={{ maxWidth: '47%' }}
          />
        </Inputs>

        <Button title={'Delete Account'} disabled onClick={onDelete} />
      </Content>
    </Container>
  );
};

export default DeleteAccountPage;
